<template>
    <div class='button_wrap'>
        <div class='one_wrap flex-between'>
            <!-- <div class="logo"><i class="iconfont icon-maisiduowei"></i></div> -->
            <div class='middle'>
                <div class='mid_content flex-start-between'>
                    <div class='content_one'>
                        <div class='content_title'>麦思多维</div>
                        <div class='toButton' @click='toPage(3,0)'>关于我们</div>
                        <div class='toButton' @click='toPage(3,1)'>联系我们</div>
                        <div><a href='https://www.maxsdsp.com' target='_blank'>公司官网</a></div>
                    </div>
                    <div class="content_two">
                        <div class="content_title">资源平台</div>
                        <div class="toButton" @click="toPage(0)">数据科学实验系统</div>
                        <div class="toButton" @click="toPage(1)">人工智能实训系统</div>
                        <div class="toButton" @click="toPage(2)">智能计算资源专区</div>
                    </div>
                    <div class="content_three">
                        <div class="content_title">专题链接</div>
                        <div><a href="http://116.63.168.79/#/login" target="_blank">期货、期权交易实验</a> </div>
                        <div><a href="http://139.9.247.137/cdClient/#/login" target="_blank">跨国投资汇率风险管理</a> </div>
                        <div><a href="http://122.9.154.146/#/login" target="_blank">证券投资实验</a> </div>
                    </div>
                </div>
            </div>
            <div class="QRcode_wrap">
                <!-- <div class="QRcode_title">关注我们</div> -->
                <div class="flex-between QRcode_img">
                    <div class="img_wrap">
                        <img src="../../assets/img/QRcodeTwo.png" alt="扫描进行关注">
                        <div class="QRcode_name">麦思多维研究院</div>
                    </div>
                    <div class="img_wrap">
                        <img src="../../assets/img/QRcode.png" alt="">
                        <div class='QRcode_name'>麦思多维科技</div>
                    </div>
                </div>

            </div>
        </div>
        <div class='copyright'>
            <div>Copyright ©2020-2022 The Project by MaxSwell.All Rights Reserved</div>
            <div><a href='https://beian.miit.gov.cn' target='_blank'>蜀ICP备19041704号-2</a></div>
        </div>
    </div>
</template>
<script>
import router from '@/router/index.js';

export default {
    data() {
        return {};
    },
    created() {

    },
    methods: {
        //基于id在本项目进行页面跳转
        toPage(id, isConnect) {
            switch (id) {
                case 0:
                    router.push({ path: '/cloudLabDetail', query: { modelId: 1 } });
                    break;
                case 1:
                    router.push({ path: '/cloudLabDetail', query: { modelId: 2 } });
                    break;
                case 2:
                    router.push('/other');
                    break;
                case 3:
                    router.push({
                        path: '/companyProfile', query: {
                            isConnect: isConnect
                        }
                    });
                    break;

            }

        }
    }
};
</script>

<style lang="scss" scoped>
.button_wrap{
    .QRcode_title{
        font-size: 25px;
        font-weight: 600;
        margin-bottom: 15px;
        line-height: 2;
    }

}

.content_two{
    div{
        position: relative;
        left: 1.5vw;
    }
}
a{
    color: white;
}
.toButton:hover{
    opacity: 0.8;
    cursor: pointer;
}
a:hover{
    opacity: 0.8;
}
.one_wrap{
    // height: 200px;
    .icon-maisiduowei{
        font-size: 60px;
    }
    div{
        text-align: left;
    }
    .QRcode_wrap{
        width: 18%;
        padding-top: 30px;
        .QRcode_img{
            width: 100%;
            text-align: center;

            .img_wrap{
                text-align: center;
                img{
                    width:100px
                }
                .QRcode_name{
                    width: 100%;
                    font-size: 16px;
                    margin-top: 10px;
                    text-align: center;
                }
            }

        }
    }
    .middle{
        width: 50%;
        letter-spacing: 1px;
        .content_title{
            font-weight: 600;
            // width: 87%;
            letter-spacing: 2px;
            font-size: 20px;
            margin-bottom: 15px;
            line-height: 1;
        }
        .mid_content{
            line-height: 2;
        }
    }

}
.button_wrap{
    width: 100%;
    box-sizing: border-box;
    padding: 20px 200px 60px 200px;
    color: white;
    background: #5277F7;
}
.copyright{
    height: 40px;
    line-height: 40px;
    width: 100%;
    padding: 0px 25%;
    display: flex;
    color: white;
    box-sizing: border-box;
    justify-content: space-around;
}
</style>
